import './App.css';
import React, { useState } from "react";
import Photobooth from "./components/Photobooth";
import { StageIntro } from "./components/stage/StageIntro";
import "./styles/global.css"
const logoSrc = "/assets/logo/lovegift-logo.png";

function App() {
  // Rèm sân khấu chào ở màn mở đầu; bấm "Lưu giữ kỷ niệm" thì rèm vén ra,
  // lộ luôn màn chọn khung (Photobooth) đã dựng sẵn phía sau.
  const [entered, setEntered] = useState(false);

  return (
    <div className="App" style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }}>
      {!entered && <StageIntro onStart={() => setEntered(true)} />}
      <div style = {{
        width: "100%",
        maxWidth: 1200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        padding: "clamp(14px, 4vw, 20px) clamp(16px, 4vw, 32px)"
      }}>
        <img src={logoSrc} alt="Logo LoveGift" style={{ width: "clamp(40px, 10vw, 56px)" }} />
        <h1 style={{
          fontFamily: "Broline",
          color: "#e9c9a4",
          margin: 0,
          fontSize: "clamp(22px, 6vw, 34px)",
          textAlign: "center"
        }}>
          lovegift photobooth
        </h1>
      </div>

      <div style={{
        flex: 1,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: "40px"
      }}
      >

      <Photobooth />

      </div>
    </div>
  );
}

export default App;
